import MonitorSelectorContainer from './MonitorSelectorContainer';

export default MonitorSelectorContainer;
